module.exports = __webpack_public_path__ + "static/media/GT-Alpina-Regular.34d2a7d4.woff2";